import React from 'react';
import 'twin.macro';

const QuantityButton = ({ children, ...props }) => {
  return (
    <button
      type="button"
      tw=" bg-gray-300 text-gray-600 hover:text-gray-700 hover:bg-gray-400 h-full w-20 cursor-pointer outline-none"
      {...props}
    >
      {children}
    </button>
  );
};

export default QuantityButton;
